import TableCell from '@mui/material/TableCell';
import React, { useMemo } from 'react';
import AchReturnedChip from '@/components/AchReturnedChip/AchReturnedChip';
import ReturnedChip from '@/components/ReturnedChip/ReturnedChip';
import {
  REFUND_METHOD,
  CHECK_TYPE_DB,
  isPendingTransactionStatus,
  isReturnedAvailableToReclaimTransactionStatus,
  isReturnedPendingReturnToBankTransactionStatus,
  isReturnedTransactionStatus,
  isStartedTransactionStatus,
} from '@/utility';

const PaymentCategoryStatusCell = ({ refund, role, getTranslatedStatus }) => {
  const isAdmin = role === 'admin';
  const isReturned = isReturnedTransactionStatus(refund.transaction_status);
  const isReturnedPendingReturnToBank = isReturnedPendingReturnToBankTransactionStatus(
    refund.transaction_status,
  );
  const isReturnedAvailableToReclaim = isReturnedAvailableToReclaimTransactionStatus(
    refund.transaction_status,
  );
  const isPending = isPendingTransactionStatus(refund.transaction_status);
  const isStarted = isStartedTransactionStatus(refund.transaction_status);
  const showAchReturnedChip =
    isAdmin && isReturned && refund.refund_method === REFUND_METHOD.ACH;
  const showInstantPaymentReturnedChip =
    isAdmin &&
    isReturned &&
    refund.refund_method === REFUND_METHOD.INSTANT_PAYMENT;
  const hasRefundMethod = Boolean(refund.refund_method);
  const hasTransactionStatus = Boolean(refund.transaction_status);
  const additionalInfo =
    refund?.additional_info || refund?.refund_additional_info;
  const hasImediatePayment = refund.pay_immediately;
  const checkTypeDisplay =
    '(Immediate payment ' +
    (refund.check_type === CHECK_TYPE_DB.PHYSICAL ? 'Check' : 'eCheck') +
    ')';

  const refundMethodDisplay = useMemo(() => {
    return hasRefundMethod ? refund.refund_method_string : 'N/A';
  }, [hasRefundMethod, refund.refund_method_string]);

  const transactionStatusDisplay = useMemo(() => {
    if (!hasTransactionStatus) {
      return null;
    }

    if (isReturned && !isAdmin) {
      return (
        <span
          style={{
            fontSize: '12px',
            color: '#ff0000',
          }}>
          {getTranslatedStatus(refund.transaction_status) || ' '}
        </span>
      );
    }
    if (!(showAchReturnedChip || showInstantPaymentReturnedChip)) {
      const transactionStatusColor = isReturned
        ? '#ff0000'
        : isReturnedAvailableToReclaim
        ? '#2e7d32'
        : isReturnedPendingReturnToBank
        ? '#ed6c02'
        : isPending
        ? '#ed6c02'
        : isStarted
        ? '#0288d1'
        : undefined;

      return (
        <span
          style={{
            fontSize: '12px',
            color: transactionStatusColor,
          }}>
          {getTranslatedStatus(refund.transaction_status) || ' '}
        </span>
      );
    }

    return null;
  }, [
    hasTransactionStatus,
    isReturned,
    isReturnedAvailableToReclaim,
    isReturnedPendingReturnToBank,
    isPending,
    isStarted,
    isAdmin,
    showAchReturnedChip,
    showInstantPaymentReturnedChip,
    refund.transaction_status,
    getTranslatedStatus,
  ]);

  const shouldShowAdditionalInfo =
    ![REFUND_METHOD.VENMO, REFUND_METHOD.PAYPAL].includes(
      refund.refund_method,
    ) && additionalInfo;

  return (
    <TableCell align='center'>
      {refundMethodDisplay}
      {refundMethodDisplay && <br />}

      {hasImediatePayment && (
        <span style={{ fontSize: '12px' }}>{checkTypeDisplay}</span>
      )}
      {hasImediatePayment && <br />}

      {showAchReturnedChip && <AchReturnedChip payment={refund} />}
      {showInstantPaymentReturnedChip && <ReturnedChip payment={refund} />}
      {(showAchReturnedChip || showInstantPaymentReturnedChip) && <br />}

      {transactionStatusDisplay}

      {transactionStatusDisplay && <br />}

      {shouldShowAdditionalInfo && (
        <span style={{ fontSize: '12px' }}>({additionalInfo})</span>
      )}
    </TableCell>
  );
};

export default PaymentCategoryStatusCell;
